import ProductItem from './ProductItem';
import { Product } from '../interfaces';
// import { RootState } from '../store/store';
import { useAppDispatch, useAppSelector } from '../store/store';
import { fetchProducts } from '../store/productSlice';
import { useEffect, useState } from 'react';

interface ProductListProps {
  products: Product[];
  keyword: string | null;
  categoryIds: number[];
}
const ProductList: React.FC<ProductListProps> = ({
  products,
  keyword,
  categoryIds,
}) => {
  const dispatch = useAppDispatch();
  const [activeProducts, setActiveProduct] = useState<Product[]>([]);
  const { productsNext, productsPrevious } = useAppSelector(
    (state) => state.products
  );
  useEffect(() => {
    setActiveProduct(
      products.filter((product) => {
        return product.isActive;
      })
    );
  }, [products]);

  return (
    <div
      className="max-w-[1400px] m-auto
    "
    >
      <div>
        {
          <>
            {products?.length === 0 && (
              <div className="flex flex-col items-center">
                <div className="text-center text-[10px] w-full font-dmsans">
                  No product found.
                </div>
              </div>
            )}
            {activeProducts.length > 0 && (
              <div>
                <div
                  className="product-list
                  flex flex-wrap
                  p-[10px] justify-center
                  gap-x-[10px] gap-y-[20px]"
                >
                  {activeProducts !== null &&
                    activeProducts.map((product: Product, index: number) => {
                      // Check if the code exists in the products array
                      return <ProductItem key={index} product={product} />;
                    })}
                </div>
              </div>
            )}
          </>
        }
      </div>
      {/* {totalPages > 1 && */}
      <div>
        <div className="flex gap-3 items-center justify-center py-4">
          {productsPrevious && (
            <button
              className="group flex items-center gap-1.5 px-4 py-2 rounded-full border border-gray-200 bg-white text-gray-500 text-sm font-medium shadow-sm hover:border-gray-400 hover:text-gray-800 hover:shadow-md transition-all duration-200"
              onClick={() => {
                if (productsPrevious) {
                  dispatch(
                    fetchProducts({ x_pagination_cursor: productsPrevious })
                  );
                }
              }}
            >
              <svg
                className="w-4 h-4 transition-transform duration-200 group-hover:-translate-x-0.5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Prev
            </button>
          )}
          {productsNext && (
            <button
              className="group flex items-center gap-1.5 px-4 py-2 rounded-full border border-gray-200 bg-white text-gray-500 text-sm font-medium shadow-sm hover:border-gray-400 hover:text-gray-800 hover:shadow-md transition-all duration-200"
              onClick={() => {
                if (productsNext) {
                  dispatch(
                    fetchProducts({
                      x_pagination_cursor: productsNext,
                      filters: { keyword, categoryIds },
                    })
                  );
                }
              }}
            >
              Next
              <svg
                className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
      {/* } */}
    </div>
  );
};

export default ProductList;
